import PagamentoLoteFavorecidosComponent from "../../components/pagamento-lote/favorecidos/PagamentoLoteFavorecidos";

export default function PagamentoLoteFavorecidos() {
  return <PagamentoLoteFavorecidosComponent />;
}
